export default {
	id: 0,
	title: 'Find Your Bearings',
	description: "",
	type: 'Primary',
	active: true,

	rewards: {
		xp: 10000,
		cash: 0,
		karma: 0, // unknown to player
	},

	// when a mission is active, tasks are watching for completion trigger ids to be sent to clear it off the list.
	// completionTrigger can be attached to downloading file, changing record, destroying log,
	// these are GAME TASKS - and must be finite and logged and tracked as a 'type', when these are fulfilled, they add the id
	// to the active quest queue, and the quest tracker will evaluate it, once all are done - the quest is checked done

	tasks: [
		{
			uid: 823741, // not sequential
			title: 'Find the modem password',
			type: '', // downloadFile, moveFile, destroyGateway, sendFile, destroyLog,
			complete: false,
			xp: 200, // locked?
			meta: {
				// people: [], // info left by the mission creator
				// gateways: [],
				// files: []
			}
		},
	]
}